import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["## Dependencies"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\nThe key is a triangle, representing the fundamental domain of the reflection\ngroup, which is actually a spherical triangle.  For simplicity, we use a\ngnomonic projection of the spherical triangle, since we want a flat\ndiagram.  Each orbit is a line in space that intersects with our triangle\nat a particular point.  (Looking at it another way, every point in the triangle\ndefines an orbit.)  This particular set of orbits are those predefined in\nvZome for icosahedral symmetry, obviously including those defined by\nZometool: blue, red, yellow, and green.\n\n## icosaOrbitsTriangle\n\nThe following function defines a reusable component that can be applied\nin other Observable notebooks.  At the moment, it only supports icosahedral\nsymmetry, and [Golden numbers](https://beta.observablehq.com/@jrus/zome-arithmetic).\nNote that you can pass in your own collection of orbits, as well as control\nwidth, height, etc.  Adjusting the height and width affects the size of the\nHTML element rectangle, but does not change the aspect ratio of the triangle.\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["*Click on a color dot to see orbit coordinates.*"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# vZome Icosahedral Orbit Triangle\n\nIn [vZome](http://vzome.com), orbits of symmetry groups are assigned colors,\nfor easy visual identification, in keeping with the design of\n[Zometool](http://zometool.com).  The orbit colors serve as a nice\nvisual identifier, but they don't tell us anything about how a given orbit\nfits into the symmetry group.  For that, we need a *key* like\nthe one shown below.\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@vorth/vzome-icosahedral-orbit-triangle@261
import define1 from "../@vorth/orbits-of-icosahedral-symmetry.js";
import define2 from "../@jrus/zome-arithmetic.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer("viewof clickedOrbit")).define("viewof clickedOrbit", ["icosaOrbitsTriangle"], function (icosaOrbitsTriangle) {
    return icosaOrbitsTriangle();
  });
  main.variable(observer("clickedOrbit")).define("clickedOrbit", ["Generators", "viewof clickedOrbit"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer()).define(["md", "clickedOrbit", "vprint"], function (md, clickedOrbit, vprint) {
    var node = md(_templateObject2());

    if (clickedOrbit.color) {
      node = md(_templateObject3(), vprint(clickedOrbit.orbit));
      node.style.color = clickedOrbit.color;
    }

    node.style.background = "#cccccc";
    return node;
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  main.variable(observer("icosaOrbitsTriangle")).define("icosaOrbitsTriangle", ["icosaOrbits", "width", "grfloat", "DOM", "d3"], function (icosaOrbits, width, grfloat, DOM, d3) {
    return function icosaOrbitsTriangle() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$orbits = _ref.orbits,
          orbits = _ref$orbits === void 0 ? icosaOrbits : _ref$orbits,
          _ref$svgWidth = _ref.svgWidth,
          svgWidth = _ref$svgWidth === void 0 ? width : _ref$svgWidth,
          _ref$height = _ref.height,
          height = _ref$height === void 0 ? 400 : _ref$height,
          _ref$stroke = _ref.stroke,
          stroke = _ref$stroke === void 0 ? 1 / 200 : _ref$stroke,
          _ref$radius = _ref.radius,
          radius = _ref$radius === void 0 ? 1 / 25 : _ref$radius;

      function project(gv2d) {
        // Note that we negate Y, to match the SVG coordinate system
        return [grfloat(gv2d[0]), -grfloat(gv2d[1])];
      }

      var _map = [0, 1, 2].map(function (i) {
        return project(icosaOrbits[i].orbit);
      }),
          _map2 = _slicedToArray(_map, 3),
          o = _map2[0],
          x = _map2[1],
          y = _map2[2];

      var svg = DOM.svg(svgWidth, height);
      svg.value = 'NO ORBIT';
      var viewBox = [-0.25 * x[0], 1.25 * y[1], 1.5 * x[0], -1.5 * y[1]];
      var container = d3.select(svg).style('max-width', '700px').style('height', 'auto').attr("viewBox", viewBox.join(" ")).append("g");
      var strokeWidth = x[0] * stroke;
      var r = x[0] * radius;
      container.append("polygon").attr("fill", "none").attr("stroke", "black").attr("stroke-width", strokeWidth).attr("points", [o, x, y].map(function (d) {
        return d.join(",");
      }).join(" "));
      container.selectAll("circle").data(orbits).enter().append("circle").attr("cx", function (d) {
        return project(d.orbit)[0];
      }).attr("cy", function (d) {
        return project(d.orbit)[1];
      }).attr("r", r).attr("fill", function (d) {
        return d.color || "#ffffff";
      }).attr("stroke", "black").attr("stroke-width", strokeWidth).on('click', function (d, i) {
        svg.value = d;
        svg.dispatchEvent(new CustomEvent("input"));
        d3.select(this).transition().attr("r", r * 2).transition().attr("r", r);
      });
      return svg;
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject5());
  });
  main.variable(observer("d3")).define("d3", ["require"], function (require) {
    return require("d3@5");
  });
  var child1 = runtime.module(define1);
  main.import("orbits", "icosaOrbits", child1);
  var child2 = runtime.module(define2);
  main.import("grfloat", child2);
  main.import("vprint", child2);
  return main;
}